/* AURAA "Lumen" — theme interactions
   All handlers are defensive: they no-op if their elements aren't present. */
(function () {
  "use strict";

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll(".reveal");
  if (reveals.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---- Mobile menu ---- */
  var burger = document.querySelector(".burger");
  var head = document.querySelector(".site-head");
  if (burger && head) {
    burger.addEventListener("click", function () {
      var open = head.classList.toggle("nav-open");
      burger.classList.toggle("is-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- PDP gallery: thumb -> stage ---- */
  var stage = document.getElementById("stage");
  var thumbs = document.querySelectorAll("#thumbs .pdp__thumb");
  if (stage && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
        var src = t.getAttribute("data-img");
        if (src) { stage.src = src; }
      });
    });
  }

  /* ---- PDP variant radios -> update price ---- */
  var priceEl = document.getElementById("pdp-price");
  var variantRadios = document.querySelectorAll(".opt-radio");
  if (priceEl && variantRadios.length) {
    variantRadios.forEach(function (r) {
      r.addEventListener("change", function () {
        if (!r.checked) { return; }
        var p = r.getAttribute("data-price");
        var c = r.getAttribute("data-compare");
        if (p) {
          var html = p;
          if (c) { html += ' <s>' + c + '</s>'; }
          priceEl.innerHTML = html;
        }
      });
    });
  }

  /* ---- Quantity steppers (works on PDP and cart) ---- */
  document.querySelectorAll(".qty").forEach(function (group) {
    var input = group.querySelector("input");
    if (!input) { return; }
    group.querySelectorAll("button[data-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(input.value || "1", 10);
        if (isNaN(v)) { v = 1; }
        v = Math.max(parseInt(input.getAttribute("min") || "1", 10), v + parseInt(b.getAttribute("data-step"), 10));
        input.value = v;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---- Collection sort: auto-submit ---- */
  var sortSelect = document.querySelector("[data-sort-select]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var form = sortSelect.closest("form");
      if (form) { form.submit(); }
    });
  }
})();
